export const HeartIcon = () => {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={32}
    viewBox="0 0 28 32"
    fill="none"
  >
    <path
      d="M27.9947 9.92841C28.2565 -0.844504 18.724 -4.83788 14.1006 8.15191C9.13885 -5.03721 -0.388678 -0.347566 0.0122656 9.92841C0.220086 15.2547 2.22702 19.5565 6.01231 23.9365L10.0491 28.4653L14.1006 32L17.6504 28.4653L21.6014 23.9365C24.2705 20.1144 27.8578 15.5626 27.9947 9.92841Z"
      fill="#799385"
    />
  </svg>
  
}